<template>
    <div>
        <div>
                <el-row>
                    <el-col><div style="color:blue">请选择时间,默认选择上个月的交易数据</div></el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="6">
                        <div class="block">
                            <el-date-picker size="mini" v-model="params.times" clearable type="daterange"
                                :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
                                end-placeholder="结束日期" align="right">
                            </el-date-picker>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <el-input placeholder="商家id" v-model="params.merchant_id" class="input-with-select" clearable
                            size="mini">
                            <el-button slot="append" icon="el-icon-search" @click="searchData">搜索</el-button>
                        </el-input>
                    </el-col>
                    <el-col :span="4">
                     <el-button type="primary" @click="getExport()" size="mini">导出数据</el-button>
                    </el-col>
                </el-row>
            <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
                <el-table-column  label="交易时间">
                    <template slot-scope="scope">
                        <small>{{ scope.row.belong_billing_date }}</small>
                    </template>
                </el-table-column>
                <el-table-column prop="merchant_id" label="商家id"></el-table-column>
                <el-table-column prop="merchant_name" label="商家名称"></el-table-column>

                  <el-table-column prop="order_total_fee" label="订单应付金额">
                    <template slot-scope="scope">
                        {{ (scope.row.order_total_fee / 100).toFixed(2) }}
                    </template>
                </el-table-column>
                 <el-table-column prop="order_total_wait_fee" label="订单待付金额">
                    <template slot-scope="scope">
                        {{ (scope.row.order_total_wait_fee / 100).toFixed(2) }}
                    </template>
                </el-table-column>

                 <el-table-column prop="order_total_wait_fee" label="订单已付金额">
                    <template slot-scope="scope">
                        {{ (scope.row.order_total_paid_fee / 100).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column  label="应付商户金额">
                    <template slot-scope="scope">
                        {{ (scope.row.total_fee / 100).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column  label="待付商户金额">
                    <template slot-scope="scope">
                        {{ (scope.row.merchant_wait_fee / 100).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="已付商户金额">
                    <template slot-scope="scope">
                        {{ (scope.row.merchant_paid_fee / 100).toFixed(2) }}
                    </template>
                </el-table-column>

                <el-table-column  label="应收平台服务费">
                    <template slot-scope="scope">
                        {{ (scope.row.platform_fee / 100).toFixed(2) }}
                    </template>
                </el-table-column>
                 <el-table-column   label="待收平台服务费">
                    <template slot-scope="scope">
                        {{ (scope.row.platform_wait_fee / 100).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column  label="已收平台服务费">
                    <template slot-scope="scope">
                        {{ (scope.row.platform_paid_fee / 100).toFixed(2) }}
                    </template>
                </el-table-column>

                <el-table-column label="应收配送费">
                    <template slot-scope="scope">
                        {{ (scope.row.freight_fee / 100).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column   label="待收配送费">
                    <template slot-scope="scope">
                        {{ (scope.row.freight_wait_fee/ 100).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column  label="已收配送费">
                    <template slot-scope="scope">
                        {{ (scope.row.freight_paid_fee/ 100).toFixed(2) }}
                    </template>
                </el-table-column>
                 <el-table-column  label="平台优惠">
                    <template slot-scope="scope">
                        {{ (scope.row.platform_active_fee / 100).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column  label="商家优惠">
                    <template slot-scope="scope">
                        {{ (scope.row.merchant_active_fee / 100).toFixed(2) }}
                    </template>
                </el-table-column>
            </el-table>
            <div class="content-center content-top-padded">
                <el-pagination background layout="total, sizes, prev, pager, next" @current-change="handleCurrentChange"
                    @size-change="handleSizeChange" :current-page.sync="params.page" :page-sizes="[10, 20, 50]"
                    :total="total_count" :page-size="params.pagesize">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import {
    getBillingTotalList,
    getBillingTotalExportList,
    getBillingDate,
    getBatchAgentPay,
    getQueryMerchantBalance,
    getQueryReserveFundBalance,
    getQueryVSPFund,
    getChooseAll
} from "../../../api/merchant";
export default {
    components: { draggable },
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            dialogFormVisible: false,
            total_count: 0,
            params: {
                bytime:1,
                page: 1,
                pagesize: 20,
            },
            dataList: [],
            loading: false,
            id: "",
            row: []
        };
    },
    computed: {
        ...mapGetters(["wheight"]),
    },
    methods: {
        getDataList() {
            this.loading = true;
            getBillingTotalList(this.params)
                .then((response) => {
                    this.dataList = response.data.data.list;
                    this.total_count = response.data.data.total_count;
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "获取列表信息出错",
                    });
                });
        },
        handleCurrentChange(page_num) {
            this.params.page = page_num;
            this.getDataList();
        },
        searchData() {
            this.params.page = 1;
            this.getDataList();
        },
        handleSizeChange(pageSize) {
            this.params.page = 1;
            this.params.pagesize = pageSize;
            this.getDataList();
        },
        //export
        getExport() {
            this.$notify({
                title: '成功',
                message: '正在导出,请稍后...',
                type: 'success'
            })

            getBillingTotalExportList(this.params).then(res => {
                if (res.data.data.status) {
                    this.$notify({
                        title: '成功',
                        message: '已加入队列!',
                        type: 'success'
                    })

                } else {
                    this.$notify({
                        title: '失败',
                        message: '出错了!',
                        type: 'error'
                    })
                }
            })


        },

    },
    mounted() {
        this.getDataList();

    },
};
</script>
<style scoped lang="scss">
.el-row {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }

    img {
        width: 90%;
    }
}

.el-col {
    border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// total.vue?ab4cf856